import React, { useState } from 'react'
import { getFileName } from '../../helper/getFileName'
import { formatDate } from '../../helper/formatDate'
import { aedLogoStyle, getDirhamImage } from '../../common/cssclasses'
import PillBtn from '../../components/PillBtn'
import { Link } from 'react-router-dom'
import CustomPopUp from '../../components/CustomPopUp'
import NetaqInput from '../../components/NetaqInput'
import { registerInHandlerShow } from './api/handlerShowApis'
import { formatDateTimeToString } from '../../helper/formatDateTimeToString'
import { formatFee } from '../../helper/formatFee'

export default function HandlerShowItem({ item, i, translate, currentLanguage, toast }) {
    const [acceptTerms, setAcceptedTerms] = useState(false);
    const baseUrl = process.env.REACT_APP_BASE_URL;

    // {
    //         "competitionId": "7f4c0e38-b9b2-45bf-a9f7-8141e7128fb6",
    //         "title": "مسابقة للتيست",
    //         "startDate": "14/07/2025",
    //         "endDate": "31/07/2025",
    //         "isOpen": true,
    //         "termsAndCodition": "يجب عليك دفع الفلوس كامله",
    //         "logoUrl": "https://site.eahs.ae:8016/Competitions/f7b64668-4637-4612-bb2e-1e2aac68b7af.jpg",
    //         "mapLocationUrl": "https://www.google.com/maps?q=85.05112877980659,-180",
    //         "address": "عنوان تيست"
    //     },
    function registerInHandler() {
        registerInHandlerShow(item?.competitionId).then((res) => {
            if (res?.status?.responseCode == "100") {
                toast.error(translate(res?.status?.detailedResponseCode, res?.status?.detailedResponseCode))
            } else if (res?.status?.responseCode == "200") {
                if (res?.result?.startsWith('http')) {
                    const returnURL = `${baseUrl}/profile?activeTab=handlerShow`
                    const url = new URL(res?.result);
                    url.searchParams.set("returnUrl", returnURL);
                    const updatedLink = url.toString();
                    window.location.href = updatedLink;
                }
            }

        })
    }


    return (
        <div
            className="col-lg-6 col-md-12 col-sm-12 mb-main"
            key={i}
        >
            <div className="p-main bg-white border-15 p-3 h-100">
                <div className='row rtl mb-form-group'>
                    <div className="col-lg-4 col-md-8 col-sm-12">
                        {!!item?.logoUrl &&
                            <img
                                className='w-100'
                                src={item?.logoUrl}
                                alt={getFileName(item?.logoUrl)}
                                onError={(e) => e.currentTarget.classList.add('d-none')}
                            />
                        }
                    </div>

                    <div className="col-lg-8 col-md-8 col-sm-12  ">
                        <div className="col-md-12 col-sm-12 ">
                            <div className="showNewTitle">
                                {item?.title}
                            </div>
                        </div>
                        <div class="showNewDetials">
                            {item?.startDate && <div class="showNewRank showNewStartDate ">
                                <div>
                                    <i class="fa fa-calendar red" ></i>{translate(
                                        "web.startDate",
                                        "Start Date"
                                    )}:
                                </div>
                                <div>{formatDateTimeToString(item?.startDateObject)}</div>
                            </div>}
                            {item?.endDate &&
                                <div class="showNewLocation showNewStartDate">
                                    <div>
                                        <i class="fa fa-calendar red" ></i>
                                        {translate("web.endDate", "End Date")}:
                                    </div>
                                    <div>
                                        {formatDateTimeToString(item?.endDateObject)}
                                    </div>
                                </div>
                            }
                            {!!item?.isCompletedRegister &&
                                <div class="showNewLocation showNewStartDate">
                                    <div>
                                        <i class="fa fa-circle red" ></i>
                                        {translate("web.status", "Status")}:
                                    </div>
                                    <div>
                                        {translate('web.registerd', 'Registerd')}
                                    </div>
                                </div>
                            }

                            <div class="showNewLocation showNewStartDate">
                                <div>
                                    <img src={getDirhamImage(currentLanguage)} alt='AED' style={aedLogoStyle} />
                                    {translate(
                                        "web.fees",
                                        "Fees"
                                    )}
                                    :
                                </div>
                                <div className='fw-bold'>
                                    {formatFee(item?.fees, translate, currentLanguage)}
                                </div>
                            </div>
                            <Link target='_blank' to={item?.mapLocationUrl} class="showNewStartDate showNewLocation mb-form-group ">
                                <div className=''>
                                    <i class="fa-solid fa-location-dot red" ></i>
                                    {translate(
                                        "web.address",
                                        "address"
                                    )}
                                    :
                                </div>
                                <div className='fw-bold red'>
                                    {item?.address}
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-sm-12 text-start  ms-auto">
                        {item?.isOpen && (item?.isCompletedRegister == false) ?
                            <CustomPopUp
                                onClick={() => registerInHandler()}
                                lockScroll
                                trigger={<div>
                                    <PillBtn
                                        isNoMargin
                                        isSubmitBtn
                                        text={translate("web.participateNow", "Participate Now")}
                                        isRed={true}
                                    />
                                </div>}
                                disabled={!acceptTerms}
                                closeOnDocumentClick={false}
                                closeOnEscape
                                key={'participate' + i}
                                content={
                                    <>
                                        <div dangerouslySetInnerHTML={{ __html: item?.termsAndCodition }} />
                                        <NetaqInput
                                            type="checkbox"
                                            checked={acceptTerms}
                                            onChange={(e) => setAcceptedTerms(e.target.checked)}
                                            name="acceptedTerms"
                                            label={translate('web.iAgreeToTheTermsAndConditions', 'I Agree To The Terms And Conditions')}
                                        />
                                    </>
                                }
                                title={item?.title}
                            /> :
                            <PillBtn
                                isNoMargin
                                isNoAction
                                text={translate("web.participateNow", "Participate Now")}
                                isRed={true}
                                isDisabled={true}
                            />

                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
